const VocFilesEndpoints = {
  POST_VOC_FILE: "/voc/files",
};

export default VocFilesEndpoints;
